<template>
  <v-container>
    <div v-if="!finished">
    <v-toolbar>
          <v-toolbar-title>Review and Create Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text v-on:click="gotoNext()">
            Next
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
      </v-toolbar>
        
    <v-card >
      <v-card-text>
        <v-simple-table>
          <tbody>
            <tr><td>Package</td><td>{{selectedProductNice}}</td><td><a  style="color:red" v-on:click="signuptab = 0">{{selectedProductErrorMessage}}</a></td></tr>
            <tr><td>Fax Number</td><td>{{formatNumber(selectedNumber)}}</td><td><a  style="color:red" v-on:click="signuptab = 1">{{selectedFaxErrorMessage}}</a></td></tr>
            <tr><td>Given Name</td><td>{{signupGivenName}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupGivenNameErrorMessage}}</a></td></tr>
            <tr><td>Last Name</td><td>{{signupLastName}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupLastNameErrorMessage}}</a></td></tr>
            <tr><td>Company Name</td><td>{{signupCompanyName}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupCompanyNameErrorMessage}}</a></td></tr>
            <tr><td>Address 1</td><td>{{signupAddress1}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupAddress1ErrorMessage}}</a></td></tr>
            <tr><td>Address 2</td><td>{{signupAddress2}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupAddress2ErrorMessage}}</a></td></tr>
            <tr><td>City</td><td>{{signupCity}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupCityErrorMessage}}</a></td></tr>
            <tr><td>Province / State</td><td>{{signupProvince}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupProvinceErrorMessage}}</a></td></tr>
            <tr><td>Postal Code / Zip</td><td>{{signupPostal}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupPostalErrorMessage}}</a></td></tr>
            <tr><td>Country</td><td>{{signupCountry}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupCountryErrorMessage}}</a></td></tr>
            <tr><td>Username / Email</td><td>{{signupEmail}}</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupUsernameErrorMessage}}</a></td></tr>
            <tr><td>Password</td><td>************</td><td><a  style="color:red" v-on:click="signuptab = 2">{{signupPasswordErrorMessage}}</a></td></tr>
          </tbody>
        </v-simple-table>
         <v-layout align-center justify-center>
          
          <v-btn color="success" v-if="allErrorMessages==''" v-on:click="createFaxhoundAccount">Create Faxhound Account</v-btn>
        </v-layout>

      </v-card-text>
    </v-card>
    </div>
    <div v-if="finished">
      <v-card>
      <v-card-title>Congratulations! Your faxhound account is ready.</v-card-title>
      <v-card-text>
        Welcome aboard. Login to the web fax portal by using the link on the top toolbar. Some other settings you may want to configure are user permissions, PDF Drop, and your fax line's timezone.
        <br><br>
        An invoice is being generated and will land in your email shortly. You will be billed monthly and can pay by credit card via Paypal.
        <br>
      </v-card-text>
      <v-card-text>
        <v-simple-table>
          <tbody>
            <tr><td>Package</td><td>{{selectedProductNice}}</td></tr>
            <tr><td>Fax Number</td><td>{{formatNumber(selectedNumber)}}</td></tr>
            <tr><td>Username / Email</td><td>{{signupEmail}}</td></tr>
            <tr><td>Password</td><td>************</td></tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
    </div>
    
  </v-container>

  
</template>

<script>

  import {mask} from 'vue-the-mask';

  import gql from 'graphql-tag';

  
const createFaxhoundAccountMutation = `
  mutation createFaxhoundAccount($input: AccountCreationInput) {
    createFaxhoundAccount(input: $input) {
      account_id
    }
  }
`;
  
  import SignupMixin from '../mixins/SignupMixin';

  export default {
    name: 'SignupEmailAndPassword',
    directives: {
      mask
    },
    mixins: [SignupMixin],
    computed: {
      
    },
    data: () => ({
      finished: false,
    }),
    methods: {
      createFaxhoundAccount: function() {
        let self = this;
        return new Promise(function(resolve,reject) {  
            let variables = { 
                input: {
                type:  'faxhound',
                number: self.selectedNumber,
                given_name: self.signupGivenName,
                last_name: self.signupLastName,
                company_name: self.signupCompanyName,
                address_1: self.signupAddress1,
                address_2: self.signupAddress2,
                city: self.signupCity,
                province: self.signupProvince,
                postal_code: self.signupPostal,
                country: self.signupCountry,
                username: self.signupEmail,
                password: self.signupPassword,
                billing_email: self.signupEmail,
                product: self.signupProduct,
                timezone: 'US/eastern',
              }
            };
            const gqlClient = self.$global.gqlClient();
            gqlClient.request(createFaxhoundAccountMutation, variables).then(function(result) {
              //let result = result.createFaxhoundAccount;
              console.log(result);
              if (result.createFaxhoundAccount) {
                self.finished = true;
              }
              resolve(true);
              //self.calculateYears(self.application.payment_periods);
            });
        });     
      },
      checkPasswords: function() {
        console.log(this.passwordConfirmed + ' v ' + this.signupPassword)
        if (this.passwordConfirmed != this.signupPassword) {
          this.passwordError = true;
        } else {
          this.passwordError = false;
        }
      },
      chooseNumber(inventory) {
        this.selectedNumber = inventory.serialno;
      },
      gotoNext() {
        this.$emit('gotoNext');
      },
    },
    beforeMount() {
    },
    watch: {
      signupPassword: function() {
        this.checkPasswords();
      },
      passwordConfirmed: function() {
        this.checkPasswords();
      }
    },
    filters: {

    },
  }
</script>
